import { useQuery } from '@tanstack/react-query';
import { getTechsNeedingCoaching } from '../services/AnalyticReportsService';
export default function useTechsNeedingCoaching(filters) {
    return useQuery(['techsNeedingCoaching', filters.values.dateRange], () => getTechsNeedingCoaching(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
